import {Component, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormModel} from "../../../../utils/form-model";
import {Validators} from "@angular/forms";

@Component({
  selector: "sbb-filterable-label-form",
  templateUrl: "./filterable-label-form.component.html",
  styleUrls: ["./filterable-label-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FilterableLabelFormComponent implements OnInit {
  @Input() model!: FormModel<FilterableLabelsFormComponentModel>;

  ngOnInit(): void {
    this.model.registerValidator("name", Validators.required);
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.onUpdate();
    }
  }

  onUpdate() {
    const updateLabelCallback = this.model.getControl("updateLabelCallback").value;
    updateLabelCallback(this.model.getControl("name").value);
  }
}

export type FilterableLabelsFormComponentModel = {
  name: string;
  dialogTitle: string;
  saveLabelCallback: (newLabel: string) => void;
  deleteLabelCallback: (originalLabel: string) => void;
  transferLabelCallback: (originalLabel: string) => void;
  updateLabelCallback?: (value: string) => void;
};
